import { z } from 'zod';
/**
 * The bot-protection token a public form submits (issue #150). Opaque to every layer except the
 * captcha adapter: the browser widget produces it, the route carries it, the adapter verifies it.
 * `contracts` names no vendor; the 2048 cap is the vendor's documented token ceiling.
 *
 * A MISSING token defaults to `''` rather than failing validation, so that "no token" and "a bad
 * token" reach the same place — the captcha check, which answers 400 `CAPTCHA_FAILED` — instead of
 * a generic `VALIDATION_FAILED` that a form cannot tell apart from a typo. The inferred type is
 * still a required `string`, so every typed caller must supply one.
 */
export const captchaTokenSchema = z.string().max(2048).default('');
//# sourceMappingURL=captcha.js.map